// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"AddressPoint-bf0897aa-scss","ic-map":"AddressPoint-301c5764-scss"};